"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VirtualMatrix = void 0;
const types_1 = require("../../../types");
class VirtualMatrix {
    constructor(rootElement, configuration) {
        this._root = typeof rootElement === "string" ? document.getElementById(rootElement) : rootElement;
        this._config = configuration;
        this._totalPixels = configuration.width * configuration.height;
    }
    get totalPixelCount() {
        return this._totalPixels;
    }
    ;
    setPixelColor(pixelNumber, r, g, b) {
        return __awaiter(this, void 0, void 0, function* () {
            const element = document.getElementById("pixel-" + pixelNumber);
            if (element) {
                element.style.backgroundColor = `rgb(${r},${g},${b})`;
            }
        });
    }
    clear() {
        for (let i = 0; i < this._totalPixels; i++) {
            this.setPixelColor(i, 0, 0, 0);
        }
    }
    display() {
        this._root.innerHTML = "";
        let pixelNumber = 0;
        for (let y = 0; y < this._config.height; y++) {
            const row = document.createElement("div");
            row.classList.add("row");
            for (let x = 0; x < this._config.width; x++) {
                const pixel = this.adjustPixelNumberBasedOnConfiguration(pixelNumber);
                const cell = document.createElement("div");
                cell.id = `pixel-${pixel}`;
                cell.classList.add("cell");
                cell.setAttribute("data-coord", `{ "x": ${x}, "y": ${y} }`);
                cell.style.backgroundColor = `rgb(0,0,0)`;
                cell.style.width = 100 / this._config.width + "%";
                row.appendChild(cell);
                pixelNumber++;
            }
            this._root.appendChild(row);
        }
    }
    adjustPixelNumberBasedOnConfiguration(pixel) {
        const currentRowNumber = Math.floor(pixel / this._config.width);
        let rowFlaggedForInversion = false;
        if (this._config.indexFrom === types_1.IndexMode.TopLeft && this._config.carriageReturnMode === types_1.CarriageReturnMode.Snaked) {
            rowFlaggedForInversion = Math.floor(currentRowNumber % 2) == 1;
        }
        else if (this._config.indexFrom === types_1.IndexMode.TopRight) {
            if (this._config.carriageReturnMode === types_1.CarriageReturnMode.Snaked) {
                rowFlaggedForInversion = Math.floor(currentRowNumber % 2) == 0;
            }
            else {
                rowFlaggedForInversion = true;
            }
        }
        let position = Math.floor(pixel % this._config.width);
        if (rowFlaggedForInversion) {
            position = ((this._config.width - 1) - position);
        }
        let snakePixelId = position + (currentRowNumber * this._config.width);
        return snakePixelId;
    }
}
exports.VirtualMatrix = VirtualMatrix;
//# sourceMappingURL=VirtualMatrix.js.map